let my_dictionary = {  
  'menu-questionnaire': 'שאלון' 
,  'menu-new': 'חדש' 
,  'menu-edit': 'עריכה' 
,  'menu-question': 'שאלה' 
,  'menu-chapter': 'פרק' 
,  'menu-back': 'חזרה' 
,  'menu-closed': 'סגורה' 
,  'menu-open': 'פתוחה' 
,  'menu-mixed': 'מעורבת' 
,  'menu-matrix': 'מטריצה' 
,  'menu-rank': 'דירוג' 
,  'menu-quota': 'מכסה' 
,  'menu-visual': 'ויזואלית' 
,  'menu-preview': 'תצוגה מקדימה' 
,  'menu-add': 'הוספה' 
,  'menu-edit-chapter': 'עריכת פרק' 
,  'menu-delete': 'מחיקה' 
,  'menu-copy': 'העתק' 
,  'menu-copyto': 'העתק אל' 
,  'menu-add-media': 'הוסף מדיה' 
,  'menu-page': 'עמוד' 
,  'menu-properties': 'מאפיינים' 
,  'menu-rules': 'חוקים' 
,  'menu-conditions': 'תנאים' 
,  'menu-settings': 'הגדרות' 
,  'menu-binds': 'קשרים' 
,  'menu-random-split': 'פיצול אקראי' 
,  'menu-edit-quest-split': 'עריכת פיצול שאלות' 
,  'menu-new-quest-split': 'פיצול שאלה חדש' 
,  'menu-random': 'אקראי' 
,  'menu-new-quest-random': 'אקראיות-שאלה חדשה' 
,  'menu-edit-quest-random': 'עריכת אקראיות-שאלה' 
,  'menu-print': 'הדפסה' 
,  'menu-data-test': 'בדיקת נתונים' 
,  'menu-simulation': 'סימולציה' 
,  'menu-design': 'עיצוב' 
,  'menu-comment': 'הערה' 
,  'menu-answer': 'תשובה' 
,  'menu-themes': 'ערכות נושא' 
,  'menu-header': 'כותרת עליונה' 
,  'menu-footer': 'כותרת תחתונה' 
,  'menu-welcome': 'ברוכים הבאים' 
,  'menu-goodbye': 'להתראות' 
,  'menu-exit': 'יציאה' 
,  'menu-skin': 'סקין' 
,  'menu-import--export': 'יבוא / יצוא' 
,  'menu-default': 'ברירת מחדל' 
,  'menu-import': 'יבוא' 
,  'menu-importmain': 'יבוא ראשי' 
,  'menu-export': 'יצוא' 
,  'menu-exportmain': 'יצוא ראשי' 
,  'menu-duplicate': 'שכפול' 
,  'menu-listfile': 'קבצי רשומות' 
,  'menu-manage': 'ניהול' 
,  'menu-view-vars': 'צפה במשתנים' 
,  'menu-project': 'פרויקט' 
,  'menu-new-project': 'פרויקט חדש' 
,  'menu-manage-project': 'ניהול פרויקט' 
,  'menu-project-groups': 'קבוצות פרויקט' 
,  'menu-permission': 'הרשאות' 
,  'menu-users': 'משתמשים' 
,  'menu-add-user': 'הוסף משתמש' 
,  'menu-edit-user': 'ערוך משתמש' 
,  'menu-groups': 'קבוצות' 
,  'menu-add-group': 'הוסף קבוצה' 
,  'menu-edit-group': 'עריכת הקבוצה' 
,  'menu-supervision': 'בקרה' 
,  'menu-general': 'כללי' 
,  'menu-map': 'מפה' 
,  'menu-list': 'רשימה' 
,  'menu-allocation': 'הקצאה' 
,  'menu-multilangual': 'מילון' 
,  'jsint-quit-sim': 'יציאה מסימולציה?' 
,  'jsint-exit': 'יציאה' 
,  'jsint-wrongnum': 'זה אינו מספר שאלה חוקי לסימולציה זו' 
,  'jqst-a-manual-num': 'נראה שיש סתירה בין מספר ידני שהכנסת לבין שאלה חדשה שאתה מנסה להכניס &lt;br&gt; המספר הידני יימחק, לתשומת לבך! &lt;br&gt; השאלה הבעייתית היא: מספר ידני=%s  מספר אורדינלי %s' 
,  'jqst-manual-numbe': 'בעיית מספר ידני' 
,  'jqst-not-yet-comp': 'עדיין לא הושלם.' 
,  'jqst-msword-is-cu': 'MSword אינו זמין כעת, נא המתן לעדכונים' 
,  'jqst-no-items-sel': 'לא נבחרו פריטים' 
,  'jqst-you-can-sele': 'באפשרותך לבחור רק שאלה אחת לעריכה' 
,  'jqst-no-questions': 'שאלות לא נבחרו' 
,  'jqst-are-you-sure': 'האם אתה בטוח שברצונך למחוק פריטים שנבחרו?' 
,  'jqst-this-manual': 'מספר שאלה זה אינו חוקי כיוון שיש כבר שאלה עם מספר זה' 
,  'jqst-this-manual80': 'מספר תשובה זה אינו חוקי כיוון שיש כבר תשובה עם מספר זה' 
,  'jqst-you-must-sel': 'עליך לבחור שאלה אחת לפחות מהטבלה הימנית' 
,  'jqst-you-must-sel27': 'נא לבחור עמודה אחת בלבד' 
,  'jqst-you-must-sel38': 'נא לבחור ערך 1 מכל תפריט' 
,  'jqst-select-paren': 'בחר שאלה או תת שאלה, לא ניתן לבחור את שניהם' 
,  'jqst-are-you-sure42': 'האם אתה בטוח שברצונך למחוק פריט זה?' 
,  'jlis-are-you-sure': 'האם אתה בטוח שברצונך למחוק את קובץ הרשומות? נתונים שיימחקו לא יוכלו להיות משוחזרים.' 
,  'jlis-will-be-comp': 'יושלם לאחר מודול מנוע הסקר.' 
,  'jlis-all-unsaved': 'כל השינויים שלא נשמרו יאבדו' 
,  'jlis-you-must-sel': 'נא לבחור לפחות 2 עמודות' 
,  'jlis-delete-origi': 'מחק את העמודות מקוריות?' 
,  'jlis-you-must-sel32': 'נא לבחור לפחות עמודה 1' 
,  'jlis-are-you-sure43': 'האם אתה בטוח שברצונך למחוק עמודות% s?' 
,  'jlis-delete': 'מחיקה' 
,  'jlis-you-must-sel29': 'נא לבחור שורה 1 לפחות' 
,  'jlis-yes': 'כן' 
,  'jlis-no': 'לא' 
,  'jlis-are-you-sure40': 'האם אתה בטוח שברצונך למחוק שורות% s?' 
,  'jlis-you-must-ass': 'אתה חייב להקצות לפחות שדה אחד כטלפון / דוא' 
,  'jper-no-items-sel': 'לא נבחרו פריטים' 
,  'jper-you-are-abou': 'אתה עומד למחוק קבוצה שלמה. אנא שקול את ההשלכות. פעולה זו תביא למחיקה של כל המשתמשים בקבוצה ללא אפשרות שחזור.' 
,  'jper-no-users-sel': 'לא נבחרו משתמשים' 
,  'jper-you-can-sele': 'באפשרותך לבחור רק קבוצה אחת לעריכה' 
,  'jper-deleting-sel': 'מחיקת משתמשים נבחרים תמחק אותם לחלוטין מהאתר והם כבר לא יהיו מסוגלים להתחבר לסקאוט. האם אתה בטוח?' 
,  'jper-you-can-sele36': 'באפשרותך לבחור רק משתמש אחד לעריכה' 
,  'jpro-are-you-sure': 'האם אתה בטוח שברצונך למחוק את הפרויקט %s?' 
,  'jpro-delete-proje': 'מחק פרויקט' 
,  'jpro-syntax-valid': 'תחביר חוקי' 
,  'jpro-error:-wrong': 'שגיאה: מבנה משתנה שגוי.' 
,  'jpro-all-question': 'כל השאלונים חייבים להיות אותו בעלי מבנה זהה, אנא בדוק את השאלות' 
,  'jpro-please-enter': 'נא להזין את שם הערך החדש' 
,  'jque-are-you-sure': 'האם אתה בטוח שברצונך למחוק את השאלון %s ?' 
,  'jque-delete-quest': 'מחק שאלון' 
,  'jque-file-size-of': 'גודל קובץ של יותר מ 50 MB' 
,  'jque-error': 'שגיאה' 
,  'jque-this-format': 'פורמט זה אינו נתמך, אנו תומכים ב: \ nImage: tif, GIF, JPG, PNG, BMP \ nVideo: AVI, WMV, MP4, MP3, flv, swf' 
,  'jque-maximum-valu': 'הערך המקסימלי חייב להיות &lt;=' 
,  'jque-cat-value-mu': 'ערך קטגוריה חייב מספר עגול' 
,  'jque-value-must-b': 'הערך חייב להיות מספרי' 
,  'jque-value-can-no': 'ערך לא יכול להיות ריק' 
,  'jque-max/min-valu': 'ערך מקסימאלי / מינימאלי חייב להיות מספרי' 
,  'jque-maximum-maxi': 'ערך מקסימום מירבי חייב להיות גדול יותר מהמינימום' 
,  'jque-min-and-max': 'ערכי מינימום ומקסימום לא יכולים להיות ריקים' 
,  'jque-upper-scale': 'ערך עליון חייב להיות גדול לפחות ב-1 מערך תחתון' 
,  'jque-maximum-valu59': 'הערך המרבי חייב להיות לפחות שווה לערך המינימאלי' 
,  'jque-max/min-valu34': 'ערך מקסימאלי / מינימאלי חייבים להיות מספרים עגולים' 
,  'jque-you-are-abou': 'אתה עומד לשנות מבנה של שאלה. פירוש הדבר הוא שאתה עלול לקבל נתונים לא עקביים או ריקים. האם אתה מאשר?' 
,  'jque-are-you-sure44': 'האם אתה בטוח שברצונך למחוק כלל אקראיות' 
,  'jque-are-you-sure45': 'האם אתה בטוח שברצונך למחוק פיצול אקראי?' 
,  'jque-are-you-sure38': 'האם אתה בטוח שברצונך לבצע פיצול אקראי?' 
,  'jque-unsaved-cond': 'תנאים שלא נשמרו יאבדו. להמשיך? כן | לא' 
,  'jsur-wrong-time-f': 'פורמט זמן שגוי' 
,  'jsur-wrong-data-f': 'פורמט  תאריך שגוי' 
,  'jsur-please-selec': 'אנא בחר אפשרות.' 
,  'jsur-you-must-loc': 'עליך לאייש את כל הקטגוריות או להקצות את כל התמונות' 
,  'jpro-please-selec': 'אנא בחר אפשרות.' 
,  'jpro-values-sum-n': 'סיכום הערכים צריך להיות 100%' 
,  'jpro-please-selec92': 'אנא בחר משתנה מוביל ידי גרירה ושחרור של משתנה C או משתנה אשכול' 
,  'jpro-please-selec40': 'אנא בחר משתני ציר ואשכול' 
,  'jpro-please-selec14': 'אנא בחר' 
,  'jque-in-this-case': 'במקרה זה מותר לך לצרף תמונות בלבד' 
,  'jsur-you-have-to': 'יש לסמן תשובה לשאלה' 
,  'jsur-you-must-sel': 'נא לבחור בין %s ל-%s תשובות (נבחרו %s)' 
,  'jsur-you-must-sel35': 'נא לבחור לפחות %s תשובות' 
,  'jsur-you-can-choo': 'לא ניתן לבחור יותר מ %s תשובות (נבחרו: %s)' 
,  'jsur-the-values-y': 'הערכים שהכנסת חייבים להסתכם בדיוק ל' 
,  'jsur-you-have-to37': 'אתה צריך להזין תשובה לשאלה' 
,  'jsur-this-field-i': 'שדה זה נדרש.' 
,  'jsur-you-have-to40': 'יש לסמן תשובה לשאלה' 
,  'jsur-you-have-to41': 'אתה צריך להזין את התשובה לשאלה של%!' 
,  'jsur-you-must-ent': 'עליך להזין לפחות {0} ולא יותר מאשר {1} תווים לשאלה זו' 
,  'jsur-you-must-ent56': 'עליך להזין לפחות {0} תווים לשאלה זו' 
,  'jsur-you-must-ent60': 'עליך להזין לא יותר מאשר {0} תווים לשאלה זו' 
,  'cal-this-user-al': 'משתמש זה כבר מחובר. אנא פנה למנהל אם אתה צריך לפתוח משתמש זה.' 
,  'cal-phone-list-c': 'רשימת כל הטלפונים' 
,  'cal-no-sample-fi': 'אין קובץ דגימה לפרויקט זה, פנה למנהל או למפקח למידע נוסף' 
,  'pro-no-fields-fo': 'אין שדות מצאו' 
,  'pro-project-succ': 'פרויקט נמחק בהצלחה' 
,  'pro-please-speci': 'נא לבחור פרויקט' 
,  'pro-listfile-not': 'קובת רשומות לא נבחר' 
,  'pro-project-succ26': 'פרויקט נשמר %s  בהצלחה' 
,  'pro-please-selec': 'אנא vars ג selec' 
,  'pro-error': 'שגיאה' 
,  'que-answers-succ': 'תשובות שנמחקו בהצלחה' 
,  'que-no-binds-for': 'לא נקשר לשאלה זו' 
,  'que-bind-saved': 'נשמר' 
,  'que-questionnair': 'שאלון' 
,  'que-questionnair29': 'שאלון נוסף בהצלחה.' 
,  'que-questionnair32': 'השאלון נשמר בהצלחה' 
,  'que-questions-wa': 'שאלות הועתקו בהצלחה' 
,  'que-questionnair34': 'השאלון נמחק בהצלחה' 
,  'que-questionnair37': 'שאלון משוכפל בהצלחה' 
,  'que-questionnair35': 'שאלון יובא בהצלחה' 
,  'que-question-suc': 'השאלה נשמרה בהצלחה' 
,  'que-question-not': 'השאלה לא נמצא' 
,  'que-maximum-valu': 'ערך המרבי חייבים להיות לפחות 1 גדול יותר מערך מינימאלי' 
,  'que-change-of-qu': 'שינוי סוג השאלה הושלם בהצלחה' 
,  'que-not-allow-me': 'לא לאפשר לתקשורת לסוג השאלה זו' 
,  'que-chapter-succ': 'הפרק נמחק בהצלחה' 
,  'que-chapter-succ26': 'הפרק נשמר בהצלחה' 
,  'que-chapter-not': 'הפרק לא נמצא' 
,  'que-design-form': 'העיצוב נשמר בהצלחה' 
,  'que-items:-%s-de': 'פריטים:% s נמחקו.' 
,  'que-random-rule': 'נשמר בהצלחה' 
,  'que-invalid-id': 'מזהה לא חוקי' 
,  'que-id:-%-delete': 'ID: נמחק%.' 
,  'que-no-questionn': 'לא נבחר שאלון' 
,  'que-condition-su': 'התנאי נשמר בהצלחה' 
,  'que-random-split': 'פיצול אקראי' 
,  'que-id:': 'ID:' 
,  'set-settings-sav': 'הגדרות נשמרו' 
,  'sur-at-first-add': 'בשאלות להוסיף 1' 
,  'cal-intermission': 'הפסקה' 
,  'cal-cancel': 'ביטול' 
,  'cal-respondent-p': 'משיב פרופיל' 
,  'cal-phone:': 'טלפון:' 
,  'cal-opening-line': 'פתיחת קו' 
,  'cal-redial-later': 'חיוג חוזר בשלב מאוחר יותר:' 
,  'cal-statuses:': 'סטטוסים:' 
,  'cal-comments': 'הערות' 
,  'cal-next-respond': 'המשיב הבא' 
,  'cal-choice-proje': 'בחר פרויקט' 
,  'cal-logout': 'התנתק' 
,  'pro-all': 'כל' 
,  'pro->values-matc': 'ערכים התואמים את קריטריוני אשכול' 
,  'pro-quantity': 'כמות' 
,  'pro-totlal': 'סה&quot;כ' 
,  'pro-choose': 'בחירה' 
,  'pro-default': 'ברירת מחדל' 
,  'pro-edit-again': 'ערוך שוב' 
,  'pro-general': 'כללי' 
,  'pro-variables-&': 'משתנים ואוכלוסייה' 
,  'pro-sampling-met': 'שיטת דגימה' 
,  'pro-quotas': 'מכסות' 
,  'pro-blacklist': 'רשימה שחורה' 
,  'pro-survey-statu': 'מצב סקר' 
,  'pro-export': 'יצוא' 
,  'pro-before-step': 'לפני השלב' 
,  'pro-after-c': 'לאחר ' 
,  'pro-distribution': 'התפלגות לפי:' 
,  'pro-value': 'ערך' 
,  'pro-percent': 'אחוזים' 
,  'pro-nest': 'קנן' 
,  'pro-quota': 'מכסה' 
,  'pro-status': 'מצב' 
,  'pro-variable': 'משתנה' 
,  'pro-question': 'שאלה' 
,  'pro-select': 'בחירה' 
,  'pro-add': 'הוספה' 
,  'pro-this-project': 'פרויקט זה' 
,  'pro-all-projects': 'כל הפרויקטים' 
,  'pro-test': 'בדיקה' 
,  'pro-save-rule': 'שמירת שלטון' 
,  'pro-load-rule': 'טען כלל' 
,  'pro-save-&-run': 'שמור והפעל' 
,  'pro-withdraw-fro': 'לסגת מ' 
,  'pro-apply-to': 'תחול על' 
,  'pro-according-to': 'על פי' 
,  'pro-action': 'פעולה' 
,  'pro-identify-by': 'זהה על ידי' 
,  'pro-time-limit': 'מגבלת זמן' 
,  'pro-recurrence': 'הישנות' 
,  'pro-run-every-(d': 'הפעל כל (ימים):' 
,  'pro-next-run:': 'ההרצה הבאה:' 
,  'pro-end-run:': 'סיים הרצה:' 
,  'pro-you-have-suc': 'החוק נשמר בהצלחה, אבל לא בוצע. האם אתה רוצה להחיל את החוק?' 
,  'pro-yes': 'כן' 
,  'pro-records-avai': 'רשומות זמינות' 
,  'pro-withdraw:': 'משוך מ' 
,  'pro-apply-to:': 'החל על:' 
,  'pro-according-to13': 'על פי:' 
,  'pro-action:': 'פעולה:' 
,  'pro-identify-by:': 'זהה על ידי:' 
,  'pro-time-limit:': 'מגבלת זמן:' 
,  'pro-recurrence:': 'חזרה:' 
,  'pro-forecast': 'תחזית' 
,  'pro-unlimited': 'בלתי מוגבל' 
,  'pro-limited': 'מוגבל' 
,  'pro-days:': 'ימים:' 
,  'pro-rule-name:': 'שם כלל:' 
,  'pro-select:': 'בחר:' 
,  'pro-other-projec': 'פרויקט אחר' 
,  'pro-select-vars': 'בחר משתנים' 
,  'pro-clusters': 'אשכולות' 
,  'pro-proportions': 'פרופורציות' 
,  'pro-export-proje': 'יצוא קבצי פרויקט:' 
,  'pro-choose-expor': 'בחר סוג יצוא:' 
,  'pro-spss-data': 'SPSS נתוני' 
,  'pro-exel-data': 'אקסל נתונים' 
,  'pro-exel-log': 'אקסל יומן' 
,  'pro-open-answers': 'תשובות פתוחות' 
,  'pro-survey-summa': 'סיכום סקר' 
,  'pro-choose-surve': 'בחר מצב סקר:' 
,  'pro-completed': 'הסתיים' 
,  'pro-use-encoding': 'השתמש בקידוד:' 
,  'pro-enabled': 'מופעל' 
,  'pro-disabled': 'כבוי' 
,  'pro-view-answers': 'צפו בתשובות' 
,  'pro-interview:': 'ראיון:' 
,  'pro-view': 'לצפות' 
,  'pro-enter-projec': 'הזן שם פרויקט:' 
,  'pro-enter-projec21': 'מספר ידני לפרויקט (לא חובה):' 
,  'pro-comments:': 'הערות:' 
,  'pro-list-file': 'קובץ רשומות' 
,  'pro-fictive': 'פיקטיבי' 
,  'pro-banner': 'באנר' 
,  'pro-other-panel': 'פאנל' 
,  'pro-you-must-sel': 'נא לבחור סוג פרויקט' 
,  'pro-choose-list': 'בחר קובץ רשימה:' 
,  'pro-choose-group': 'בחר קבוצה:' 
,  'pro-no-group': 'אף קבוצה' 
,  'pro-choose-quest': 'בחר שאלון:' 
,  'pro--select-': 'את הבחירה ב-' 
,  'pro-sample-size:': 'גודל מדגם:' 
,  'pro-ratio:': 'יחס:' 
,  'pro-interval-set': 'הגדרות מרווח' 
,  'pro-daily': 'יומי' 
,  'pro-weekly': 'שבועי' 
,  'pro-month': 'חודש' 
,  'pro-quarterly': 'רבעון' 
,  'pro-portion:': 'חלק:' 
,  'pro-current-port': 'חלק נוכחי:' 
,  'pro-list-file-se': 'רשימת רגישות קובץ:' 
,  'pro-static': 'סטטי' 
,  'pro-cumulative': 'מצטבר' 
,  'pro-set-all-valu': 'כוון את כל הערכים על' 
,  'pro-test-info': 'בדיקת מידע' 
,  'pro-drag-and-dro': 'גרור ושחרר משתנה מוביל' 
,  'pro-choose-depen': 'משתנים תלויים (לא חובה)' 
,  'pro-choose-a-sam': 'בחר שיטת דגימה:' 
,  'pro-axis-variabl': 'משתנה ציר' 
,  'pro-clusterd-var': 'משתנה לאשכול' 
,  'pro-create': 'ליצור' 
,  'pro-cluster-list': 'רשימת אשכולות:' 
,  'pro-axis-values': 'ערכי ציר נמצאו' 
,  'pro-axis-values20': 'ערכי ציר נבחר' 
,  'pro-total-record': 'סך הכל נמצא רשומים' 
,  'pro-records-sele': 'רשומות הנבחרות' 
,  'pro-%-in-populat': '% באוכלוסייה' 
,  'pro-probability': 'הסתברות' 
,  'pro-stratified': 'שכבות' 
,  'pro-clustered': 'אשכול' 
,  'pro-systematic': 'שיטתי' 
,  'pro-as-is': 'לפי הסדר הקיים' 
,  'pro-total:': 'סהכ' 
,  'pro-distribution12': 'הפצה' 
,  'pro-create&edit': 'יצירה ועריכת סטטוסי הענות' 
,  'pro-setup-email': 'תבנית הגדרת דואר אלקטרוני' 
,  'pro-setup-email20': 'תזכורת הגדרת דואר אלקטרוני' 
,  'pro-automatic-cl': 'חייגן אוטומטי לתחנה' 
,  'pro-setup-respon': 'מדיניות החזרת משיבים' 
,  'pro-languages-se': 'שפות' 
,  'pro-automatic-ba': 'איזון אוטומטי:' 
,  'pro-act': 'פעולות' 
,  'pro-create-sampl': 'צור קובץ דגימה' 
,  'pro-send-test-su': 'שלח סקר בדיקה' 
,  'pro-send-to-resp': 'שלח למשיבים' 
,  'pro-send-reminde': 'שלח תזכורת למשיבים' 
,  'pro-create-gener': 'קבל קישור' 
,  'pro-set-online': 'הפוך למקוון' 
,  'pro-set-offline': 'הפוך ללא מקוון' 
,  'pro-online': 'מקוון' 
,  'pro-shedule': 'יומן' 
,  'pro-remiders': 'תזכורות' 
,  'pro-offline-mode': 'מצב לא מקוון' 
,  'pro-save-templat': 'שמור תבנית' 
,  'pro-sender:': 'שולח:' 
,  'pro-subject:': 'נושא:' 
,  'pro-language-sel': 'בחירת שפה' 
,  'pro-drag-and-dro51': 'גרור ושחררת שפה מתפריט שמאלי לתפריט מימין' 
,  'pro-available-la': 'שפות זמינות' 
,  'pro-default-lang': 'שפת ברירת מחדל' 
,  'pro-other-langua': 'שפות אחרות' 
,  'pro-setup-offlin': 'התקנת מועד מצב לא מקוון' 
,  'pro-setup-automa': 'התקנת תזכורות אוטומטיות' 
,  'pro-choose-dates': 'בחר תאריכים ושמור זמנים לתזכורות' 
,  'pro-remider': 'תזכורת' 
,  'pro-set-priority': 'קביעת עדיפות לרשומות שהוקצו למראיינים:' 
,  'pro-selected-sor': 'בחירת היררכיה לפילוח' 
,  'pro-translate': 'לתרגם' 
,  'pro-new-status': 'מעמד חדש' 
,  'pro-return-every': 'לחזור כל' 
,  'pro-show-status': 'הצגת מצב' 
,  'pro-start&end': 'נקודת התחלה וסיום' 
,  'pro-start': 'כניסה' 
,  'pro-end': 'הסוף' 
,  'pro-import-&-exp': 'יבוא ויצוא סטטוסים' 
,  'pro-import': 'יבוא' 
,  'pro-sort': 'סוג' 
,  'pro-please-enter': 'נא להזין את שם הערך חדש:' 
,  'pro-records-avai18': 'רשומות זמינות:' 
,  'pro-c-variables': 'C משתני' 
,  'pro-f-variables': 'F משתני' 
,  'pro-variables': 'משתנים' 
,  'pro-main|surv': 'ראשי | הסקר' 
,  'pro-nesting': 'קנון' 
,  'pro-recode': 'לקודד מחדש' 
,  'pro-load-templat': 'טען תבנית' 
,  'pro-asc': 'סדר עולה' 
,  'pro-desc': 'סדר יורד' 
,  'que-get-started': 'התחל לעבוד' 
,  'que-about-scout': 'אודות סקאוט' 
,  'que-our-website': 'האתר שלנו' 
,  'que-report-an-er': 'דווח על שגיאה' 
,  'que-log-out': 'התנתק' 
,  'que-listfile': 'קובץ רשומות' 
,  'que-project': 'פרויקט' 
,  'que-permission': 'הרשאות' 
,  'que-supervision': 'בקרה' 
,  'que-encoding': 'קידוד' 
,  'que-settings': 'הגדרות' 
,  'que-sqdl': 'SQDL' 
,  'que-properties': 'מאפיינים' 
,  'que-rules': 'חוקים' 
,  'que-preview': 'תצוגה מקדימה' 
,  'que-design': 'עיצוב' 
,  'que-themes': 'נושאים' 
,  'que-parent': 'הורה' 
,  'que-remove': 'להסיר' 
,  'que-bind': 'לקשור' 
,  'que-unbind': 'להתיר' 
,  'que-previous': 'קודם' 
,  'que-choose-optio': 'בחר באפשרות' 
,  'que-show': 'להראות' 
,  'que-hide': 'להסתיר' 
,  'que-parent6': 'הורה' 
,  'que-gradual': 'הדרגתי' 
,  'que-current-ques': 'שאלון נוכחי' 
,  'que-selected-que': 'שאלות נבחרות' 
,  'que-filter': 'סינון' 
,  'que-select-a-que': 'בחר שאלה, השאלות הנבחרות שלך תועתקנה לפני שאלה זו.' 
,  'que-go-to-end': 'לך לסוף' 
,  'que-copy': 'העתק' 
,  'que-some-problem': 'חלק מהבעיות התגלו כאשר deliting' 
,  'que-menu-font-ex': 'הטקסט יעוצב כך' 
,  'que-use-parent-s': 'השתמש בסגנון הורה' 
,  'que-default-font': 'גופן ברירת מחדל' 
,  'que-font-size': 'גודל גופן' 
,  'que-color': 'צבע' 
,  'que-background-c': 'צבע רקע' 
,  'que-bold': 'בולד' 
,  'que-italic': 'נטוי' 
,  'que-save-&-edit': 'שמור ועריכה' 
,  'que-save-&-exit': 'שמור ויציאה' 
,  'que-manual': 'ידני' 
,  'que-question-tex': 'טקסט שאלה' 
,  'que-media': 'מדייה' 
,  'que-script': 'סקריפט' 
,  'que-rnd': 'רנד' 
,  'que-chapter': 'פרק' 
,  'que-start\end': 'התחל \ סיום' 
,  'que-click-on-fil': 'לחץ על השדה כדי לבחור צבע.' 
,  'que-ruller-color': 'צבע סרגל' 
,  'que-pointer-colo': 'צבע פוינטר:' 
,  'que-show-selecte': 'הצג את הערך הנבחר תחת הסרגל:' 
,  'que-finished': 'הסתיים' 
,  'que-page-propert': 'מאפייני דף' 
,  'que-distance:-qu': 'מרחק: שאלה לתשובות' 
,  'que-distance:-to': 'מרחק: לשאלה הבאה' 
,  'que-apply-to-all': 'החל על כל השאלונים' 
,  'que-choice-quest': 'שאלון לבחירה' 
,  'que-slelect-skin': 'בחירת סקין' 
,  'que-url': 'URL' 
,  'que-save-&-exi': 'שמירה ויציאה' 
,  'que-use-default': 'השתמש בברירת מחדל' 
,  'que-remark': 'הערה' 
,  'que-answer': 'תשובה' 
,  'que-closed': 'סגור' 
,  'que-open': 'לפתוח' 
,  'que-mixed': 'מעורב' 
,  'que-matrix': 'מטריצה' 
,  'que-visual': 'חזותי' 
,  'que-add-media': 'הוסף מדיה' 
,  'que-page': 'עמוד' 
,  'que-conditions': 'תנאים' 
,  'que-binds': 'נקשר' 
,  'que-print': 'דפס' 
,  'que-data-test': 'בדיקת נתונים' 
,  'que-simulation': 'הדמיה' 
,  'que-header': 'כותרת' 
,  'que-footer': 'תחתון' 
,  'que-welcome': 'ברוך הבא' 
,  'que-goodbye': 'להתראות' 
,  'que-choice-quest33': 'שאלון בחירה לשכפל' 
,  'que-enter-file-l': 'הזן את מיקום קובץ' 
,  'que-enter-questi': 'שם השאלון (השאר ריק להעברת השם המקורי)' 
,  'que-this-may-tak': 'זה עשוי לקחת כמה דקות' 
,  'que-font-size:': 'גודל גופן:' 
,  'que-color:': 'צבע:' 
,  'que-background-c17': 'צבע רקע:' 
,  'que-hidden-comme': 'הערות מוסתרות' 
,  'que-chapter-text': 'טקסט פרק' 
,  'que-hide-chapter': 'הסתר פרק' 
,  'que-single-pick': 'כפתור רדיו בחירה בודדת' 
,  'que-single-pick21': 'קומבו בוקס בחירה בודדת' 
,  'que-multi-answer': 'תיבת סימון ריבוי תשובות' 
,  'que-no-answer-co': 'אין תגובת תשובה' 
,  'que-show-navigat': 'הצג כפתורי שליטה בנגן המדיה' 
,  'que-hide-next-bu': 'הסתר את לחצן הבא עד לסיום נגינת הקליפ:' 
,  'que-hide-text:': 'הסתר את הטקסט:' 
,  'que-text': 'טקסט שאלה' 
,  'que-upload': 'העלה' 
,  'que-border:': 'גבול:' 
,  'que-question-fil': 'שאלת צבע מילוי:' 
,  'que-text-size:': 'גודל טקסט:' 
,  'que-text-color:': 'צבע טקסט:' 
,  'que-select-quest': 'בחר שאלה:' 
,  'que-insert': 'להכניס' 
,  'que-chained': 'משורשרת' 
,  'que-horizontal': 'מאוזן' 
,  'que-vertical': 'אנכי' 
,  'que-multi-compar': 'השוואה מרובה' 
,  'que-sum': 'סכום' 
,  'que-form': 'טופס' 
,  'que-rank': 'דירוג' 
,  'que-visual-compa': 'השוואה ויזואלית' 
,  'que-browse...': 'עיון ...' 
,  'que-show-text:': 'הצג את הטקסט של התשובות' 
,  'que-any-text': 'כל טקסט' 
,  'que-number': 'מספר' 
,  'que-date': 'תאריך' 
,  'que-time': 'זמן' 
,  'que-select-point': 'בחר סגנון מצביע:' 
,  'que-drop-down': 'דרופ דאון' 
,  'que-fit-in': 'הכנסה במשבצת' 
,  'que-podium': 'פודיום' 
,  'que-limit-answer': 'מספר תשובות (מינימום \ מקסימום)' 
,  'que-time-limit-(': 'מגבלת זמן (שניות)' 
,  'que-display-on-s': 'להציג על מסך' 
,  'que-save-answer': 'שמור את הזמן שנדרש לענות' 
,  'que-save-order-o': 'שמירת סדר התשובות' 
,  'que-indicate': 'להצביע' 
,  'que-ordinal': 'אורדינלי' 
,  'que-hide4': 'להסתיר' 
,  'que-click-object': 'לחץ על אובייקט' 
,  'que-ruler': 'סרגל' 
,  'que-shelf-simula': 'מדמה מדף' 
,  'que-question-com': 'הערות שאלה' 
,  'que-answers-list': 'רשימת תשובות' 
,  'que-mul': 'מול' 
,  'que-rnd3': 'רנד' 
,  'que-actions': 'פעולות' 
,  'que-list-new-ans': 'רשימת תשובות חדשות' 
,  'que-add-filter': 'הוסף מסנן' 
,  'que-parent-quest': 'שאלת אם' 
,  'que-id': 'ID' 
,  'que-child-questi': 'שאלת בת' 
,  'que-answer-scale': 'סרגל תשובות לכל שאלות הבת' 
,  'que-same': 'זהה' 
,  'que-different': 'שונה' 
,  'que-closed-answe': 'תשובות סגורות' 
,  'que-answer-text': 'ענה טקסט' 
,  'que-answer-scale19': 'תשובה לקנה מידה ש:' 
,  'que-id=': 'ID =' 
,  'que-answer-scale28': 'סרגל תשובות לשאלה הכל' 
,  'que-hidden-comme14': 'הערה נסתרת' 
,  'que-must': 'חובה' 
,  'que-prewous': 'הקודם' 
,  'que-allow-n\a-op': 'אפשר אופציית לא רלוונטי' 
,  'que-enter-custom': 'הזן את הטקסט מותאם אישית. ברירת מחדל היא N/A' 
,  'que-organize': 'סדר' 
,  'que-child-column': 'טור שאלת בת' 
,  'que-child-row': 'שורת שאלת בת' 
,  'que-answer-scale12': 'סרגל תשובות' 
,  'que-open-answer': 'תשובה פתוחה' 
,  'que-min': 'מינימום' 
,  'que-ranking-cate': 'קטגוריות דירוג' 
,  'que-images': 'תמונות' 
,  'que-exactly': 'בדיוק' 
,  'que-range': 'טווח' 
,  'que-minimun:': 'מינימום:' 
,  'que-maximum:': 'מרבי:' 
,  'que-force-pointe': 'הכנס מצביע לקטגוריות' 
,  'que-free-movemen': 'תנועה חופשית שמור נקודה עשרונית' 
,  'que-lower-scale': 'תחילת סולם' 
,  'que-upper-scale': 'סוף סולם' 
,  'que-limit-charac': 'הגבל תווים' 
,  'que-max': 'מקסימום' 
,  'que-question-sub': 'תת-סוג שאלה' 
,  'que-rank-type': 'סוג הדירוג' 
,  'que-question-man': 'מספר שאלה ידנית' 
,  'que-question-id': 'ID שאלה' 
,  'que-children-que': 'סוג שאלות בת' 
,  'que-children-que23': 'סוג שאלות בת' 
,  'que-questions-su': 'תת-סוג שאלה' 
,  'que-allow-multia': 'אפשר רב-תשובות' 
,  'que-answers': 'תשובות' 
,  'que-name:': 'שם:' 
,  'que-alocated-to': 'מוקצה ל' 
,  'que-disabled': 'לא פעיל' 
,  'que-random-quest': 'חוקי רנדום לשאלות' 
,  'que-display:': 'הצגה:' 
,  'que-of': 'של' 
,  'que-questions-li': 'רשימת שאלות:' 
,  'que-select-quest15': 'בחר שאלה' 
,  'que-random-split22': 'שאלות לפיצול אקראי' 
,  'que-random-split20': 'תשובות לפיצול אקראי' 
,  'que-for': 'עבור' 
,  'que-if': 'אם' 
,  'que-gui': 'ממשק' 
,  'que-skip': 'לדלג' 
,  'que-to:': 'עד:' 
,  'que-validate': 'וידוא' 
,  'que-comment:': 'הערה:' 
,  'que-set': 'לקבוע' 
,  'que-else': 'אחרת' 
,  'que-else-if': 'אחרת אם' 
,  'que-question:': 'שאלה:' 
,  'que-select-quest16': 'בחר שאלה ' 
,  'que-is': 'האם' 
,  'que-is-not': 'האם לא' 
,  'que-any': 'כל' 
,  'que-or': 'או' 
,  'que-and': 'ו -' 
,  'que-continue': 'המשך' 
,  'que-content': 'תוכן' 
,  'que-order': 'סדר' 
,  'que-entrance': 'כניסה' 
,  'que-exit': 'יציאה' 
,  'que-filter:': 'מסנן:' 
,  'set-some-problem': 'מספר בעיות התגלו עם הטופס שהוגש.' 
,  'set-user-has-bee': 'המשתמש נשמר.' 
,  'set-available-la': 'שפות זמינות' 
,  'set-language-nam': 'שם שפה באנגלית' 
,  'set-name-in-orig': 'שם בשפת המקור' 
,  'set-language-dir': 'כיוון שפה' 
,  'set-import-&-exp': 'יבוא ויצוא' 
,  'set-import-&-exp15': 'יבוא ויצוא' 
,  'set-full-diction': 'מילון מלא' 
,  'set-search': 'חפש' 
,  'set-constant-nam': 'שם קבוע' 
,  'sup-choode-group': 'בחר מ:' 
,  'sup-free': 'חופשי' 
,  'sup-interviewers': 'מראיינים' 
,  'sup-release-all': 'לשחרר את כל' 
,  'sup-move-all': 'שחרר' 
,  'sup-created': 'נוצר' 
,  'sup-last-used': 'משמש אחרון' 
,  'sup-allocated': 'מוקצה' 
,  'sup-allocate': 'להקצות' 
,  'sup-need': 'צריך' 
,  'sup-done': 'נעשה' 
,  'sup-left': 'נותר' 
,  'sup-allocated9': 'מוקצים' 
,  'sup-status': 'סטטוס' 
,  'sup-remove': 'להסיר' 
,  'sup-info': 'מידע' 
,  'sup-view-&-monit': 'צפי ובקרה' 
,  'sup-allocate\rel': 'להקצות \ שחרור' 
,  'sup-project-name': 'שם פרויקט' 
,  'sup-log-off': 'התנתקות' 
,  'sur-quit': 'יציאה' 
,  'sur-end-of-simul': 'סוף סימולציה' 
,  'sur-questionnair': 'שם שאלון:' 
,  'sur-questionnair23': 'הערות שאלון:' 
,  'sur-questionnair19': 'תאריך שאלון:' 
,  'sur-questionnair21': 'יוצר שאלון:' 
,  'sur-skip-to-q': 'דלג לשאלה' 
,  'sur-next>>>': 'הבא' 
,  'sur-time-left:': 'זמן שנותר:' 
,  'sur-enter': 'כניסה' 
,  'sur-(rnd)': '(רנד)' 
,  'sur-(mul)': '(מול)' 
,  'sur-show-scripts': 'הצג סקריפטים' 
,  'sur-last-modifie': 'השתנה לאחרונה:' 
,  'sur-creation-dat': 'תאריך יצירה:' 
,  'sur-creator-name': 'שם בורא:' 
,  'sur-n/a': 'לא רלוונטי' 
,  'sur-your-choice:': 'הבחירה שלך:' 
,  'sur-drop-here': 'שחרר כאן' 
,  'jsur-exit': 'יציאה' 
,  'sur-qchar': 'ש' 
,  'jsur-wrongnum': 'זה אינו מספר שאלה חוקי לשאלון זה' 
,  'jsur-quit-sim': 'יציאה מסימולציה?' 
,  'set-export': 'יצא' 
,  'set-import': 'יבא' 
,  'set-import-file': 'בחר קובץ' 
,  'set-selct-lang': 'בחר שפות' 
,  'que-assistance': 'עזרה' 
,  'jlis-are-you-sure-to-delete': 'האם אתה בטוח שברצונך למחוק את החוק הזה?' 
,  'sur-your-choice': 'הבחירה שלך:' 
,  'jsur-sum-between': 'הערכים שהכנסת חייבים להיות בין %s ל %s' 
,  'jsur-you-mus-aloca': 'יש למקם את כל הקטגוריות או להקצות את כל התמונות' 
,  'jsur-quit-sur': 'בחרת לצאת מסקר זה לפני סיומו, אך אם תבחר לחזור, תוכל לחזור בכל עת ולהמשיך מהיכן שהפסקת. האם לצאת מהסקר?' 
,  'menu-postcollection': 'קידוד והגהה' 
,  'menu-postcollection-encoding': 'קידוד' 
,  'menu-postcollection-proofreading': 'הגהה' 
,  'menu-postcollection-export': 'ייצוא' 
,  'jenc-more': 'יותר' 
,  'jenc-less': 'פחות' 
,  'jenc-is-currently-allocated-to': 'כרגע מוקצה ל' 
,  'jenc-warning-allocated-1': 'זהירות! שחרור משתמש זה אם עדיין במהלך עבודה יכול לגרום לאובדן של כל הנתונים לסקר זה, נא נהג בזהירות' 
,  'jenc-warning-allocated-2': 'לא ניתן לשחרר משתמש שנמצא אונליין. צור קשר עם מנהל קידוד אם ברצונך לבצע פעולה זו. אנא וודא שהמשתמש אינו מחובר ופעיל למניעת אובדן מידע.' 
,  'jenc-warning-allocated-3': 'זהירות! שחרור משתמש זה אם עדיין במהלך עבודה יכול לגרום לאובדן של כל הנתונים לסקר זה, נא נהג בזהירות' 
,  'pro-by-variable': 'לפי משתנה' 
,  'pro-manual-emails': 'אימיילים ידניים' 
,  'pro-by-status': 'לפי סטטוס' 
,  'pro-save&edit': 'שמור עכשיו' 
,  'pro-save&exit': 'שמירה ויציאה' 
,  'sup-i-totaltime': 'סהכ זמן' 
,  'sup-i-stoptime': 'זמן עצירה' 
,  'sup-i-tasktime': 'זמן משימה' 
,  'pro-subject-empty': 'נושא חסר' 
,  'pro-sender-empty': 'כתובת שולח חסרה' 
,  'pro-sendername-empty': 'שם שולח חסר' 
,  'pro-select-empty': 'נא לבחור אפשרות שליחה!' 
,  'set-keyword': 'לפי מילות מפתח' 
,  'pro-recreate-sampl': 'קובץ דגימה' 
,  'pro-manualsend-overquota': 'לא ניתן לשלוח מיילים ידניים כי הינך משתמש במכסות C' 
,  'pro-sendername': 'שם השולח:' 
,  'pro-send-test-remind': 'שלח תזכורת בדיקה' 
,  'pro-header-sent-test-survey': 'שלח שאלון בדיקה' 
,  'pro-header-sent-test-reminder': 'תזכורת בדיקה נשלחה' 
,  'pro-send-survey': 'הפץ שאלון' 
,  'pro-send-reminder': 'הפץ תזכורת' 
,  'pro-template-empty': 'לא הוגדר טמפלט אימייל' 
,  'pro-filtered-send': 'שלח פופאם' 
,  'pro-pro--select-': 'בחר שאלון' 
,  'pro-absent-emails': 'אימיילים לא נמצאו:' 
,  'pro-incorrect-emails': 'אימיילים שגויים:' 
,  'pro-search': 'חיפוש' 
,  'pro-blacklist-items': 'פריטי רשימה שחורה' 
,  'pro-filter': 'סינון:' 
,  'pro-email': 'אימייל' 
,  'pro-date': 'תאריכים' 
,  'pro-comments': 'הערות' 
,  'pro-select-all': 'בחר הכל' 
,  'pro-remove-entry': 'הסר רשומה' 
,  'pro-select-status': 'בחר סטטוס' 
,  'pro-not-started': 'לא התחיל' 
,  'pro-stopped': 'הפסיק' 
,  'pro-finished': 'הסתיים' 
,  'pro-not-sent': 'לא נשלח' 
,  'pro-select-vars-values': 'ערכים' 
,  'pro-filter-all': 'הכל' 
,  'pro-unselect-all': 'הסר בחירות' 
,  'pro-Date-blacklist': 'תאריך חסימה' 
,  'pro-Comments-blacklist': 'הערות' 
,  'pro-Email-blacklist': 'אי-מייל/טלפון' 
,  'jpro-remove-error': 'שגיאת הסרה' 
,  'jpro-remove-success': 'הוסר בהצלחה' 
,  'que-rule-deleted': 'התנאי נמחק' 
,  'que-new-rule': 'תנאי חדש' 
,  'que-entr-cond': 'תנאי כניסה' 
,  'que-exit-cond': 'תנאי יציאה' 
,  'jpro-bad-quotas': 'הסקר כולל שאלות מכסה שלא הוגדרו להן ערכים, או שערכיהן לא מסתכמים ב100%. נא לוודא ולתקן לפני העברת הסקר למצב מקוון. מידע נוסף בלשונית מכסות' 
,  'que-single-pick22': 'בחירה יחידה נגללת' 
,  'jpro-conf-recreate': 'אתה הולך למחוק את כל הסקרים שנאספו, פעולה זו אינה הפיכה. האם אתה בטוח לחלוטין?' 
,  'pro-change-size': 'שנה גודל' 
,  'pro-manage-size': 'שנה גודל מדגם' 
,  'pro-select-project-edit': 'בחר פרויקט' 
,  'que-mandatory': 'חובה' 
,  'super-export-to-excel': 'ייצא לאקסל' 
,  'super-statuses-by-inter': 'סטטוסים לפי סוקר' 
,  'survey-select': ' נא לבחור תשובה' 
,  'jenc-confirm-delete': 'האם ברצונך למחוק את הקטגוריה?' 
,  'jenc-warning-released-1': 'זהירות! שחרור משתמש זה בעודו עובד עלול לגרום לאובדן מידע. נא לוודא שהמשתמש מנותק. האם ברצונך לשחרר משתמש זה?' 
,  'jenc-warning-released-2': 'אין אפשרות לשחרר משתמש כשהוא מחובר. נא ליצור קשר עם מנהל במידה והמשתמש אינו באמת מחובר ונדרשת הסרה. זהירות! שחרור משתמש זה בזמן עבודה תוביל לאיבוד מידע.' 
,  'jenc-please-re-allocate-this': 'שיוך משתמש מחדש נדרש כדי לקדודד שאלה זו' 
,  'jenc-is-currently-released': 'משוחרר כרגע' 
,  'jenc-this-question-is-now-allocated-to': 'השאלה הוקצתה ל' 
,  'que-limit-charac-val': 'הגבל ערכים' 
,  'jenc-is-dont-copy': 'לא ניתן להעתיק קטגוריה זו' 
,  'jenc-is-currently-copy': 'הקטגוריות הועתקו בהצלחה.' 
,  'jenc-structure-error-dont-copy': 'שגיאת מבנה נתונים' 
,  'jenc-error-category-exist': 'קטגוריה כבר קיימת' 
,  'sup-que-quot-error': 'שאלת מכסה עודכנה. ערכי המכסה בפרויקט עבור שאלה זו צריכים הגדרה מחדש' 
,  'pro-concatenated-vars': 'שרשור משתנה' 
,  'pro-concat-del-error': 'לא ניתן למחוק משתנה זה, הפרויקט כבר החל. נא לאתחל את הדגימה דרך ' 
,  'pro-concat-del-confirm': 'האם למחוק משתנה זה?' 
,  'jpro-concat-del-error': 'לא ניתן למחוק משתנה זה, הפרויקט כבר החל. נא לאתחל את הדגימה דרך ' 
,  'jpro-concat-del-confirm': 'האם למחוק משתנה זה?' 
,  'jpro-select-listfile': 'בחר קובץ רשומות' 
,  'pro-change-sample': 'שנה מדגם' 
,  'pro_current': 'נוכחי' 
,  'pro_new': 'חדש' 
,  'pro_add_list_file': 'הוסף מקובץ הרשומות:' 
,  'pro_select_list_file': 'בחר קובץ רשומות' 
,  'pro-total': 'סה' 
,  'pro-new-quota': 'מכסה חדשה' 
,  'menu-new-bind': 'קשר חדש' 
,  'menu-list-bind': 'קשרים מוגדרים' 
,  'que-bind-deleted': 'קשר נמחק' 
,  'jque-fordel-cond': 'האם ברצונך למחוק תנאי זה?' 
,  'jpro-all': 'הכל' 
,  'jlis-blacklisting': 'מכניס לרשימה השחורה' 
,  'jlis-records': 'רשומות' 
,  'pro-manual-blacklis': '' 
,  'pro-manual-blacklist': 'רשימה שחורה ידנית' 
,  'pro-rules': 'חוקים' 
,  'pro-bt-save-edit': 'שמור והמשך לערוך' 
,  'pro-bt-save-exit': 'שמירה ויציאה' 
,  'pro-bt-blacklist': 'הוסף לרשימה השחורה' 
,  'jlis-blacklist-settings': 'הגדרות פריט ברשימה שחורה' 
,  'jlis-select-limit': 'הגבלת משך זמן (ימים)' 
,  'jlis-cencel': 'ביטול' 
,  'jlis-blacklist': 'הכנס לרשימה השחורה' 
,  'pro-Days-left-blacklist': 'ימים שנותרו' 
,  'pro-Project-blacklist': 'פרויקט' 
,  'pro-Source-blacklist': 'מקור' 
,  'pro-Withdraw': 'משוך מ' 
,  'pro-Apply': 'החל על' 
,  'pro-According': 'לפי' 
,  'pro-add-rule': 'הוסף חוק' 
,  'jenc-show-default': 'הצג במקביל: לפני ואחרי הגהה' 
,  'proof-modified-by': 'מגיה' 
,  'proof-last-modified': 'שינוי אחרון' 
,  'proof-end-time': 'זמן סיום הראיון' 
,  'proof-id': 'ID' 
,  'jenc-custom-questions-dont-save': 'לא נשמר' 
,  'jenc-proofing-questions-currently-save': 'שינויי הגהה נשמרו' 
,  'pro-st-completed': 'הושלם' 
,  'pro-st-notstarted': 'לא התחיל' 
,  'pro-st-stopped': 'הפסיק' 
,  'pro-st-inuse': 'בשימוש' 
,  'pro-save': 'שמור' 
,  'menu-cencel': 'ביטול' 
,  'pro_save': 'שמור' 
,  'pro-source': 'מקור' 
,  'pro-project': 'פרויקט' 
,  'pro-until': 'מספר ימים שנשארו' 
,  'pro-untill': 'מספר ימים שנשארו' 
,  'jpro-statuses': 'סטטוס' 
,  'que-que-show': 'הצג את הנבחרים' 
,  'que-que-hide': 'הסתר את הנבחרים' 
,  'que-err-splitcnt': 'ספירה שגויה' 
,  'jque-err-splitcnt': 'נא להקליד מספר (נמוך ממספר הפריטים שנבחרו)' 
,  'jqst-skin-saved': 'סקין נשמר' 
,  'que-que-parent66': 'לפי שאלת-אב' 
,  'que-que-gradual': 'בחירה מדורגת' 
,  'jpro-items-add-to-blacklist': 'פריטים נוספו לרשימה השחורה' 
,  'que-hide-qdesign': 'הסתר שאלה |' 
,  'que-hide-qtext': 'הסתר טקסט' 
,  'jqst-reset-confirm': 'פעולה זו תאתחל את העיצוב לברירת מחדל, האם הינך בטוח?' 
,  'que-reset-skin': 'שחזור ברירת מחדל' 
,  'jpro-done': 'הסתיים' 
,  'jpro-in-use': 'בשימוש' 
,  'jpro-stopped': 'הפסיק' 
,  'jpro-over-quota': 'סוננו' 
,  'pro-blacklist-rules': 'חוקי רשימה שחורה' 
,  'jlis-exec-rules': 'שמור והחל את החוק' 
,  'jlis-nothing-added-in-black-list': 'החוק נשמר אך לא נוספו רשומות לרשימה השחורה.' 
,  'jlis-test-rules': 'ביטול' 
,  'jlis-add-to-black-list 54 jlis-respondents': '' 
,  'jlis-add-to-black-list': 'החוק נשמר - לרשימה השחורה נוספו' 
,  'jlis-respondents': 'נמענים' 
,  'jno-answers-selected': 'לא נבחרו תשובות' 
,  'jname-empty': 'השם ריק' 
,  'jcnt-absent': 'נא להקליד מספר (נמוך מכמות הפרטים שנבחרו9' 
,  'surv-mobile-disallow': ' מתנצלים, סקר זה אינו זמין לטלפונים ניידים וטאבלטים.' 
,  'prop-subquest-label': 'הצג מספר תת-שאלה' 
,  'jsur-tilt-mobile-msg': 'הפוך מסך למצב מאוזן' 
,  'jproj-are you sure': 'כל הקטגוריות מכל השאלות יועתקו מהפרויקט הנבחר לפרויקט הנוכחי. מאשר?' 
,  'jproj-yes': 'כן' 
,  'jproj-no': 'לא' 
,  'jpro-remove-rules-success': 'החוק נמחק' 
,  'jlis-unlimited': 'ללא הגבלת זמן' 
,  'surv-already-completed': 'נראה כי כבר סיימת סקר זה.' 
,  'pro-spam-revention': 'חסימת ספאם' 
,  'pro-spam-revention:': 'חסימת ספאם:' 
,  'jenc-bt-restore': 'אחזר' 
,  'surv-already-finished': 'המענה על סקר זה הסתיים, נשמח לשמוע את דעתך בפעם הבאה. למידע נוסף אנא &lt;a href=' 
,  'jint-edit-comment': 'ערוך' 
,  'jint-delete-comment': 'מחק' 
,  'jint-failed': 'נכשל' 
,  'jint-busy': 'עסוק' 
,  'surv-unavailable': 'תודה רבה על נכונותך להשיב. הסקר הסתיים. נשמח לשמוע את דעתך בפעמים הבאות &lt;br&gt;&lt;span style=' 
,  'super-response-total': 'סהכ' 
,  'super-total-respondents-in-sample-file': 'סהכ' 
,  'surv-wrong': 'נראה כי יש בעיה כלשהי עם סקר זה. לדיווח נא ללחוץ &lt;a href=' 
,  'super-respondent-usage-summary': 'סיכום שימוש במשיבים' 
,  'surv-wrong-action': 'פעולה שגויה' 
,  'surv-no-hash': 'לא נמצאה תגית האש' 
,  'surv-tech-fail': 'מצטערים, שגיאת מערכת  - אנא נסו במועד מאוחר יותר. לתמיכה לחץ&lt;a href=' 
,  'surv-wrong-lang': 'תקלה בבחירת השפה' 
,  'surv-screened': 'תודה על שיתוף הפעולה, לצערנו מאפייניך אינם מתאימים למענה על סקר זה' 
,  'surv-wrong-token': 'טוקן שגוי או אינו קיים' 
,  'jenc-bt-clear': 'נקה' 
,  'jenc-hide-default': 'הסתר מקורי' 
,  'project-has-been-deleted': 'נא לשלוח את המלה ' 
,  'jlis-listfileexst': 'כבר קיימת רשימה עם שם זה' 
,  'que-question-options': 'בחר אפשרויות שאלה' 
,  'jsur-you-must-ent61': 'יש להזין מספר בין {0} ל{1}' 
,  'jsur-you-must-ent62': 'יש להזין מספר לא פחות מ-{0}' 
,  'jsur-you-must-ent63': 'יש להזין מספר לא גדול מ-{0}' 
,  'jque-err-chkcnt': 'לא נבחרה אף שאלה' 
,  'que-question-pos': 'מספר סידורי' 
,  'jlis-yes-remove': 'כן' 
,  'jlis-no-remove': 'לא' 
,  'jlis-confirmation-remove-entry': 'רשומות שנבחרו יוסרו מרשימה שחורה, האם הינך בטוח?' 
,  'jsup-over-negative': 'נא להזין מספר חיובי בלבד' 
,  'jsup-set-over': 'יש להזין את כמות החריגה מהמכסה לפני הפיכתה לפעילה' 
,  'jque-need-set-max': 'חובה להגדיר ערך מקסימלי!' 
,  'jlis-add-to-black-list-test': 'חוק זה יכניס לרשימה שחורה' 
,  'jlis-add-to-black-list-realy': 'חוק נשמר' 
,  'jlis-nothing-added-in-black-list-test': 'חוק לא נשמר' 
,  'jlis-nothing-added-in-black-list-realy': 'חוק התווסף אבל לא נוספו רשומות לרשימה שחורה' 
,  'survey-success': '     הסקר הסתיים בהצלחה, תודה על השתתפותך.' 
,  'menu-mobile-simulation': 'מובייל' 
,  'pro-maccabi-task': 'XperTo' 
,  'que-opn-min': 'מינימום' 
,  'que-opn-max': 'מקסימום' 
,  'pro-btn-call': 'טלפוני' 
,  'pro-btn-web': 'אינטרנטי' 
,  'pro-response-statuses': 'סטטוסי היענות' 
,  'pro-return-policy': 'מדיניות חזרה' 
,  'pro-create-testlink': 'קבל קישור לבדיקת הסקר' 
,  'pro-status-edit': 'ערוך' 
,  'pro-existing-statuses': 'סטטוסים קיימים' 
,  'pro-new': 'חדש' 
,  'pro-set-default': 'הגדר ברירת מחדל' 
,  'pro-status-name': 'שם סטטוס' 
,  'pro-status-type': 'סוג' 
,  'pro-status-remove-number': 'הסר מספר' 
,  'pro-status-loop-return': 'חזור' 
,  'pro-status-loop-minutes': 'חזרות' 
,  'pro-status-loop-time': 'ניסיונות' 
,  'jpro-status-select': 'בחר תבנית' 
,  'pro-status-meeting': 'פגישה' 
,  'pro-status-language': 'שפה' 
,  'pro-status-show-status': 'הצג סטטוס' 
,  'pro-status-show-select': 'בחר להציג' 
,  'pro-status-show-start': 'התחל' 
,  'pro-status-show-end': 'סיום' 
,  'pro-status-show-both': 'שניהם' 
,  'pro-status-save': 'שמור' 
,  'jpro-status-show-select': 'הצג סטטוס:' 
,  'sup-int-alocated': 'מוקצים' 
,  'jint-intermission': 'עצירה' 
,  'pro-status-final-remove': 'סופי' 
,  'menu-sup-map': 'מפת סוקרים' 
,  'sup-int-byproj': 'פרויקט' 
,  'sup-int-state': 'מצב' 
,  'sup-state-inteview': 'ריאיון' 
,  'sup-state-online': 'מקוון' 
,  'sup-state-intermission': 'הפסקה' 
,  'sup-state-offline': 'לא מקוון' 
,  'js-sup-map-watch': 'צפייה במסך' 
,  'js-sup-map-logof': 'התנתק' 
,  'js-sup-map-message': 'שליחת הודעה' 
,  'js-sup-map-release': 'לשחרר' 
,  'sup-int-name': 'שם' 
,  'sup-int-time': 'זמן' 
,  'sup-int-netproduct': 'תפוקה נטו' 
,  'sup-int-avgtime': 'זמן ממוצע' 
,  'sup-int-projname': 'שם פרויקט' 
,  'sup-int-last-q': 'שאלה אחרונה' 
,  'sup-inte-of-q': 'מתוך' 
,  'jinterview-no-phone-selected': 'לא נבחר מספר טלפון' 
,  'jint-set-phone-status': 'יש לקבוע סטטוס למספר הטלפון לפני מעבר למשיב הבא' 
,  'jint-current-phone-nostatus': 'טרם נקבע סטטוס למספר הטלפון שבטיפול עכשיו' 
,  'pro-delete': 'מחק' 
,  'jpro-status-confirm-delete': 'האם אתה בטוח שברצונך למחוק את הסטטוס?' 
,  'jpro-status-dont-delete': 'לא ניתן להסיר סטטוס זה!' 
,  'jpro-status-save': 'הסטטוס נשמר' 
,  'jint-overquota-not-survey': 'המשב במכסה מלאה, לא ניתן להמשיך' 
,  'pro-sending-problem': 'מדווח על בעיה' 
,  'super-phonelist-usage-summary': 'סיכום השימוש במספרי הטלפון' 
,  'super-restore-selected': 'אחזר בחירה' 
,  'super-select-by': 'בחיר לפי' 
,  'jpro-status-language-dublicate': 'סטטוס מסוג שפה קיים כבר - אין ליצור יותר מאחד.' 
,  'jpro-status-select-type-require': 'יש לבחור סוג סטטוס' 
,  'super-no-c-quotas': 'לא נמצאו מכסות C' 
,  'jpro-status-name-require': 'אנא הזן שם לסטטוס.' 
,  'super-restored-from': 'אוחזר מסטטוס' 
,  'jpro-confirm-template-new': 'האם הינך בטוח שברצונך להסיר כל הסטטוסים הקיימים בפרויקט ולהתחיל בנק סטטוסים חדש?' 
,  'menu-sup-daily': 'דו``ח יומי' 
,  'proj-error-respondent-exists': 'שגיאה! לפרויקט יש נתונים שנאספו' 
,  'proj-status-used': 'שגיאה! הסטטוס בשימוש בשאלון' 
,  'jqst-bind-del-confirm': 'למחוק את החוק?' 
,  'questionnaire_ordinal_number': 'מספר סידורי לשאלה' 
,  'questionnaire_manual_number': 'מספר ידני לשאלה' 
,  'questionnaire_question_id': 'זהות שאלה' 
,  'pro-project-comment': 'הערות פרויקט' 
,  'pro-insert-comments': '' 
,  'supervision-filter': 'סינון' 
,  'supervision-filter-date': 'תאריך' 
,  'jpro-status-name-wrong': 'הזנת תווים לא חוקיים - השם לא נשמר.' 
,  'super-questionnaire': 'שאלון' 
,  'super-startedon': 'התחיל ב' 
,  'super-endedon': 'הסתיים ב' 
,  'super-goal': 'יעד' 
,  'proj-auto-dialing': 'חייגן' 
,  'pro-call-log': 'יומן שיחות' 
,  'pro-export-token': 'קוד משיב' 
,  'sup-freq': 'תדירות' 
,  'sup-freq-select': 'בחר' 
,  'sup-freq-answer': 'תשובה' 
,  'sup-freq-count': 'כמות' 
,  'super-id': 'מראיין' 
,  'super-recovered': 'ראיונות שחודשו' 
,  'super-completed': 'ראיונות שהושלמו' 
,  'super-total': 'סך ראיונות' 
,  'super-exit': 'יציאות' 
,  'super-intermission': 'הפסקות מנוחה' 
,  'super-task': 'הפסקות למשימות אחרות' 
,  'super-net_production': 'תפוקה נטו' 
,  'super-gross_production': 'תפוקה ברוטו' 
,  'super-intermission_time': 'זמן מנוחה' 
,  'super-task_time': 'זמן במשימות אחרות' 
,  'super-interview_time': 'זמן ראיונות כולל' 
,  'super-recovered_interview_time': 'זמן בראיונות שחודשו' 
,  'super-free_time': 'משוחרר' 
,  'super-total_time': 'סך זמן' 
,  'super-net_distance': 'כמות להשלמת היעד נטו' 
,  'super-gross_distance': 'כמות להשלמת היעד ברוטו' 
,  'super-avg_time': 'משך סקר בממוצע' 
,  'super-last_login': 'כניסה אחרונה למערכת' 
,  'super-last_logout': 'יציאה אחרונה מהמערכת' 
,  'super-pbx_shirking_time': 'זמן השתמטות כולל' 
,  'super-pbx_loss_time': 'איבוד זמן כולל' 
,  'super-pbx_stopped_time': 'זמן עצירה כולל' 
,  'super-pbx_dialing_time': 'זמן חיוג כולל' 
,  'super-pbx_talking_time': 'זמן שיחות כולל' 
,  'super-completed_interview_time': 'זמן בראיונות שלמים' 
,  'jpro-confirm-template-delete': 'האם אתה בטוח שברצונך למחוק את סט הסטטוסים?' 
,  'jpro-confirm-template-save': 'שמור סט סטטוסים בשם:' 
,  'super-columns-mapping': 'בחירת עמודות לתצוגה' 
,  'surv-production-template': 'התפוקה הנוכחית שלך היא %production%, הפרש של %fx% מהתפוקה הממוצעת בסקר זה.&lt;br/&gt;סיימת %total% סקרים מלאים עד כה.' 
,  'pro-fromProject-blacklist': 'מ' 
,  'que-form-delete': 'מחק' 
,  'super-total-phones-in-sample-file': 'סהכ' 
,  'super-status-inuse': 'בשימוש' 
,  'super-status-free': 'פנוי' 
,  'super-status-pending': 'בתהליך' 
,  'super-status-locked': 'נעול' 
,  'super-table-general': 'כללי' 
,  'super-table-interviewers': 'סוקרים' 
,  'super-table-cquotas': 'מכסות C' 
,  'sup-int-totalbreak': 'סהכ' 
,  'sup-int-goal': 'יעד' 
,  'super-project': 'פרויקט' 
,  'super-ratio': 'יחס מענה' 
,  'jsur-validate-message-digits': 'ספרות' 
,  'jpro-err-create-sf-before': 'נא לאתחל דגימה לפני בחירה בפעולה זו' 
,  'jpro-err-delete1': 'פרויקט זה מקוון ואינו יכול להימחק' 
,  'sup-state-free': 'פנוי' 
,  'menu-reporting': 'דיווח' 
,  'sup-filter-date-start': 'סינון תאריך התחלה' 
,  'sup-filter-date-end': 'סינון תאריך סיום' 
,  'sup-quest-id': 'זהות שאלון' 
,  'sup-quest-name': 'שם שאלון' 
,  'super-interviewer_id': 'מס.זיהוי סוקר' 
,  'super-interviewer_name': 'סוקר' 
,  'que-warning-used-in-projects': 'סקר זה בשימוש של פרויקט. נא לוודא שכל שינוי שייעשה לא יפגע בנתונים הנאספים' 
,  'sup-state-incall': 'בשיחה' 
,  'sup-role-interviewer': 'מראיין' 
,  'sup-role-non-interviewer': 'לא מראיין' 
,  'sup-state-task': 'משימה' 
,  'que-switch-project': 'עבור לפרויקט אחר' 
,  'sup-int-grossproduct': 'תפוקה ברוטו' 
,  'jsur-validate-message-required': 'נא לענות על השאלה.' 
,  'pro-s-variables': 'משתני S' 
,  'sup-state-interview': 'ראיון' 
,  'super-daily-per-interveiwer': 'לפי מראיינים' 
,  'pro-choose-observer': 'בחר צופה' 
,  'super-cnt-interviewers': 'ספירה' 
,  'jpro-select-var-cval': 'נא לבחור ערכים עבור כל משתנה C' 
,  'menu-interviewers': 'סוקרים' 
,  'sup-clean-filter': 'הסר סינון' 
,  'que-mh-unique': 'Qunique' 
,  'que-mh-noparelel': 'נא לא לבחור באותה תשובה פעמיים' 
,  'que-mh-mustsel': 'נדרש לבחור בכל אחת מהתשובות' 
,  'pro-select-project-export': 'בחר פרויקט לייצוא' 
,  'pro-choose-export-type': 'כיצד ברצונך לייצא את הפרויקט הנבחר' 
,  'pro-statuses-call': 'סטטוסי שיחה' 
,  'pro-statuses-web': 'סטטוסי ווב' 
,  'pro-history': 'היסטוריה' 
,  'pro-last': 'אחרון' 
,  'menu-exprt-project': 'יצוא' 
,  'que-bind-type-q-q': 'שאלה - שאלה' 
,  'que-bind-type-a-a': 'תשובה - תשובה' 
,  'que-bind-type': 'נא לבחור סוג' 
,  'menu-binds-horiz': 'חיבור במצב מאוזן' 
,  'que-bind-incase': 'במקרה ש' 
,  'que-bind-child': 'מחובר' 
,  'que-bind-type-q-a': 'שאלה - תשובה' 
,  'que-bind-type-a-q': 'תשובה - שאלה' 
,  'quest-cond-count-of-answers': 'Count of answers of' 
,  'jsqst-proj-sort-notify': 'השאלון בשימוש על ידי פרויקט. האם להזיז את הפריטים שנבחרו?' 
,  'que-mh-fixed': 'כותרת מקובעת' 
,  'jsqst-proj-delete-notify': 'השאלון בשימוש על ידי פרויקט. האם למחוק את הפריטים שנבחרו?' 
,  'jsqst-proj-new-notify': 'השאלון בשימוש על ידי פרויקט. האם להוסיף את הפריטים החדשים?' 
,  'jsqst-copyto-notify': 'השאלון בשימוש על ידי פרויקט. האם להעתיק את הפריטים שנבחרו?' 
,  'pro-ans-behalf': 'ענה בשם מרואיין' 
,  'jsur-rank-car-err': 'יש לדרג %s תשובות בלבד' 
,  'jsur-rank-catmin-err': 'נא לדרג לפחות %s תשובות' 
,  'jsur-numvalid-err': 'נא לרשום מספר תקין' 
,  'pro-kiosk-mode': 'מצב קיוסק' 
,  'pro-kiosk-mode-descr': 'התחלת סקר מחדש פשוטה על אותו מכשיר' 
,  'jsur-start-over': 'התחל סקר חדש' 
,  'jsur-cancel': 'בטל' 
,  'jsur-continue': 'המשך' 
,  'jsur-select': 'בחר' 
,  'jsur-selected': 'נבחר' 
,  'jsur-rank-sel': 'בחר' 
,  'jsur-rank-drophere': 'דרג/י תשובות על ידי גרירה לכאן' 
,  'jsur-month-list': 'ינו_פבר_מרץ_אפר_מאי_יונ_יול_אוג_ספט_אוק_נוב_דצמ' 
,  'jsur-exited-title': 'יצאת מהסקר בהצלחה' 
,  'jsur-exited-descr': 'ניתן לחזור לסקר מהמקום שבו הפסקת' 
,  'jsur-exited-start': 'חזור לשאלון' 
,  'jsur-mpick-count-err': 'נא לבחור %s תשובות (נבחרו: %s)' 
,  'pro-concat-notice': 'שים לב! משתנים משורשרים לא מיושמים עד שמאתחים את קובץ הרשומות' 
,  'sup-main-contrl': 'בקרה מרכזית' 
,  'sup-monitor-title': 'צפיה ומעקב' 
,  'sup-quotas': 'מכסות' 
,  'sup-reponse': 'תשובות' 
,  'sup-logs': 'לוגים' 
,  'sup-production': 'תפוקה' 
,  'pro-offline': 'לא מקוון' 
,  'pro-supervision': 'מסך פיקוח' 
,  'pro-gps-title': 'איתור מיקום' 
,  'pro-gps-descr': 'בקש מיקום ממשיבים' 
,  'pro-gps-force': 'דרישת מיקום חובה' 
,  'jsur-hm_nparalel': 'אינך יכול לבחור תשובות מקבילות' 
,  'jsur-hm_all': 'אנא בדוק את כל התשובות' 
,  'que-quest-edit': 'ערוך' 
,  'pro-dist-method': 'בחר שיטת הפצה' 
,  'pro-spec-types': '' 
,  'pro-properties': 'מאפייני פרויקט' 
,  'pro-vars-title': 'בחר משתנים וצור אוכלוסית על סמך קובץ הרשומות' 
,  'pro-choose-var': 'בחר משתנה' 
,  'pro-quota-selvar': 'צור מכסות למשתנים שנבחרו' 
,  'pro-quota-svar': 'נא לבחור משתנה' 
,  'pro-setup-wizard': 'אשף שאלון' 
,  'pro-load': 'טען' 
,  'pro-status-number': 'סטטוס טלפון' 
,  'pro-status-empty': 'ריק' 
,  'pro-status-restored': 'אוחזר' 
,  'jque-num-rows': 'מספר שורות' 
,  'pro-status-title': 'סטטוס פרויקט' 
,  'jlist-chacngepop-top': 'זה ישפיע על הפרויקטים הבאים' 
,  'sup-i-inside': 'בפנים' 
,  'sup-i-used': 'רשומות נוצלו' 
,  'jsur-logout': 'התנתק' 
,  'jsur-curproj': 'פרויקט נוכחי' 
,  'jsur-prj-change': 'שינוי' 
,  'jsur-status': 'סטטוס' 
,  'jsur-finished': 'הסתיים בהצלחה' 
,  'jsur-respid': 'ID משיב' 
,  'jsur-done-intlist': 'הסקרים שלי' 
,  'jsur-edit-open': 'עריכת תשובות פתוחות' 
,  'jsur-resp-profile': 'פרופיל משיב' 
,  'jsur-resp-name': 'שם משיב' 
,  'jsur-phone-nums': 'מספרי טלפון' 
,  'jsur-btn-manual': 'חיוג ידני' 
,  'jsur-btn-remove': 'הסר' 
,  'jsur-comments': 'הערות' 
,  'jsur-btn-post': 'הגב' 
,  'jsur-write-post': 'כתוב כאן' 
,  'jsur-click-dial': 'לחץ לחיוג' 
,  'jsur-updates': 'עדכונים' 
,  'jsur-nextresp': 'המשיב הבא' 
,  'jsur-btn-tosurvey': 'לשאלון' 
,  'jsur-btn-failed': 'נכשל' 
,  'jsur-btn-dealto': 'נא לחייג ל' 
,  'jsur-btn-nextnumber': 'המספר הבא' 
,  'jsur-phonestat': 'בחר מספר' 
,  'cal-select-proj': 'בחר פרויקט' 
,  'cal-btn-start': 'התחל' 
,  'cal-btn-simulate': 'הדמיית סקר' 
,  'jsur-st-online': 'מקוון' 
,  'jsur-st-on-break': 'הפסקה' 
,  'jsur-st-on-task': 'משימה' 
,  'jsur-st-in-task': 'משימה' 
,  'jsur-dial-num': 'חייג למספר' 
,  'menu-projects': 'פרויקטים' 
,  'menu-live': 'שידור חי' 
,  'menu-production': 'תפוקה' 
,  'menu-attendance': 'נוכחות' 
,  'sup-i-readytime': 'זמן מוכן לעבודה' 
,  'sup-i-station': '# עמדה' 
,  'sup-i-breaktime': 'זמן הפסקה' 
,  'sup-i-lostlogout': 'התנתקות אחרונה' 
,  'sup-i-lastologin': 'התחברות אחרונה' 
,  'sup-i-curproj': 'פרויקט נוכחי' 
,  'sup-i-exists': 'יציאות באמצע' 
,  'sup-i-recovered': 'הושלמו מהאמצע' 
,  'sup-i-complete': 'הושלמו' 
,  'sup-i-goal': 'יעד' 
,  'sup-i-surtime': 'משך ראיון ממוצע' 
,  'sup-i-gross': 'ברוטו' 
,  'sup-i-net': 'נטו' 
,  'sup-i-totlaint': 'סהכ ראיונות' 
,  'sup-i-suration': 'משך סטטוס' 
,  'sup-i-status': 'סטטוס' 
,  'sup-i-name': 'שם' 
,  'sup-i-msgall-lable': 'תוכן ההודעה' 
,  'sup-i-msgall-title': 'שליחת הודעה לכולם' 
,  'sup-i-msgall': 'שלח הודעה לכולם' 
,  'sup-i-discon-all': 'נתק את כולם' 
,  'sup-i-logoff': 'ניתוק אי פעילות (דקות)' 
,  'sup-i-alert': 'התראה אי עבודה (דקות)' 
,  'sup-i-managecol': 'ניהול עמודות' 
,  'sup-i-live-title': 'תצוגת מראיינים חיה' 
,  'sup-p-managesur': 'ניהול ראיונות' 
,  'sup-p-complete-menu': 'סקרים שהושלמו' 
,  'sup-p-projcomnment': 'הערות פרויקט' 
,  'sup-p-alocinter': 'הקצאת סוקרים' 
,  'sup-p-production': 'תפוקה' 
,  'sup-p-statreport': 'דוח סטטוסים' 
,  'sup-p-ansdist': 'התפלגות תשובות' 
,  'sup-p-quotastat': 'סטטוס מכסות' 
,  'sup-p-views': 'תצוגה' 
,  'sup-p-nodetaild': 'אין מידע' 
,  'sup-p-detaild': 'פירוט' 
,  'sup-p-remove': 'הסרה' 
,  'sup-p-action': 'פעולות' 
,  'sup-p-status': 'סטטוס' 
,  'sup-p-interviews': 'מראיינים' 
,  'sup-p-left': 'נותרו' 
,  'sup-p-completed': 'נדגמו' 
,  'sup-p-to-sample': 'לדגימה' 
,  'sup-proj-name': 'שם פרויקט' 
,  'sup-pro-id': 'ID' 
,  'sup-i-ended-at': 'הסתיים ב' 
,  'sup-i-started-at': 'התחיל ב' 
,  'sup-i-survey-id': 'ID סקר' 
,  'sup-rem-confirm-title': 'פעולה זו תמחק את כל הסקרים שלא הסתיימו' 
,  'sup-remove-infinish': 'הסר סקרים שלא הסתיימו' 
,  'sup-serch-id-title': 'חפש סקר ID' 
,  'sup-comm-add': 'הוסף הערה' 
,  'sup-comm-lable': 'כתוב הערה' 
,  'sup-inter-serach': 'חיפוש מראיינים' 
,  'sup-inter-all': 'כולם' 
,  'sup-inter-list': 'רשימת מראיינים' 
,  'sup-aloc-inter-title': 'הקצאת סוקרים' 
,  'sup-inter-add': 'הוסף מראיינים' 
,  'sup-inter-aloc': 'מראיינים מוקצים' 
,  'sup-prod-avg': 'סהכ ממוצע' 
,  'sup-prod-sum': 'סכום סהכ' 
,  'sup-prod-rep-title': 'דוח תפוקה' 
,  'sup-a-completed': 'סיימו בלבד' 
,  'sup-a-all': 'כולם' 
,  'sup-a-selected': 'נבחרו' 
,  'sup-a-q-langs': 'שפות' 
,  'sup-a-q-status': 'סטטוס סקר' 
,  'sup-a-qlist': 'שאלות לתצוגה' 
,  'sup-s-byinters': 'לפי מראיינים' 
,  'status-RESTORE': 'אחזר' 
,  'status-RETURNED_LOOP': 'אוחזרו_תזמון' 
,  'status-RETURNED_LANGAUGE': 'אוחזרו_שפה' 
,  'status-RETURNED_MEETING': 'אוחזרו_פגישה' 
,  'status-RESTORED': 'אוחזרו' 
,  'status-EMPTY': 'ריק' 
,  'status-IN_USE': 'בשימוש' 
,  'sup-s-count': 'כמות' 
,  'sup-s-precent': 'אחוזים' 
,  'sup-s-res-count': 'מספר אחזורים' 
,  'sup-s-rec-restore': 'רשומות אוחזרו' 
,  'sup-s-call-export': 'ייצא יומן שיחות' 
,  'sup-q-oveflow': 'גלישה מעבר' 
,  'sup-q-extras': 'אקסטרות' 
,  'sup-q-refusals': 'סירובים' 
,  'sup-q-in-inter': 'בריאון' 
,  'sup-q-open': 'פתוח' 
,  'sup-q-closed': 'סגור' 
,  'sup-mod-confirm': 'נא לאשר פעולה זו' 
,  'sup-i-arrived': 'נוכח' 
,  'sup-i-chekin': 'הגיע' 
,  'sup-i-project': 'פרויקט' 
,  'sup-i-start-shift': 'התחלת משמרת' 
,  'sup-i-username': 'שם משתמש' 
,  'sup-i-cheking': 'האם הגיע' 
,  'sup-all': 'כולם' 
,  'sup-list-by-proj': 'הצג לפי פרויקט' 
,  'sup-attend-title': 'מראיינים במשמרת זו' 
,  'sup-but-apply': 'אישור' 
,  'sup-to-date': 'לתאריך' 
,  'sup-select-date': 'בחר תאריך' 
,  'sup-from-date': 'מתאריך' 
,  'sup-m-byproj': 'לפי פרויקט' 
,  'sup-m-by-inter': 'לפי מראיין' 
,  'sup-default-col': 'הגדרת ברירת מחדל' 
,  'sup-mod-cancel': 'ביטול' 
,  'sup-mod-ok': 'אישור' 
,  'sup-i-disconnect-all': 'לנתק את כולם' 
,  'sup-i-minutes': 'דקות' 
,  'sup-qst': 'שאלון' 
,  'sup-p-total-sum': 'סיכום סהכ' 
,  'sup-p-total-avg': 'סהכ ממוצע' 
,  'status-RETURNED_LANGUAGE': 'חזר_שפה' 
,  'status-SUCCESS': 'הצליח' 
,  'status-ZERO_QUOTA': 'אפס_מכסה' 
,  'status-OVER_QUOTA': 'חריגת_מכסה' 
,  'status-EXTRA': 'אקסטרה' 
,  'status-BURNED': 'נוצלו' 
,  'jsur-phone': 'טלפון' 
,  'sup-i-totalrec': 'סהכ רשומות' 
,  'super-sample_size': 'Sample size' 
,  'super-name': 'Name' 
,  'super-remaining': 'Remaining' 
,  'sup-prod-rep-status': 'Status report' 
,  'sup-no-results': 'No data to display.' 
,  'sup-select-diff-dates': 'Plese try to select different dates' 
,  'proj-cookie-days': 'ימים' 
,  'proj-cookie-unlim': 'Unlimited' 
,  'proj-cookie-expiry': 'Spam prevention' 
,  'sup-call-reord': 'Call recording' 
,  'sup-i-respodent': 'Respondent' 
,  'jsur-pbx-stop-dial': 'עצור חיוג' 
,  'jsur-pbx-stop-dialing': 'עצור חיוג' 
,  'jsur-pbx-dialing': 'מחייג...' 
,  'jsur-connect-pbx-error': 'נכשל בהתחברות למרכזיה' 
,  'jsur-redial': 'חייג שנית' 
,  'jsur-exit-survey': 'צא מהסקר' 
,  'jsur-diconn-title': 'השיחה התנתקה' 
,  'jsur-connect-pbx': 'מתחבר למרכזייה' 
} 
             if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') { module.exports = my_dictionary } else { window.my_dictionary = my_dictionary } 